import { Link, makeStyles, Theme } from "@material-ui/core";

type Param = {
    href: string,
    className?: string
}

const useStyle = makeStyles((theme: Theme) => ({

    root: {

    }
}));

/* 
Security
    https://material-ui.com/components/links/
    When you use target="_blank" with Links, it is recommended to always set rel="noopener" or rel="noreferrer" 
    when linking to third party content.

    rel="noopener" 
    prevents the new page from being able to access the window.opener property and ensures it runs in a separate process. 
    Without this, the target page can potentially redirect your page to a malicious URL.

    rel="noreferrer" has the same effect, but also prevents the Referer header from being sent to the new page. 
    Removing the referrer header will affect analytics.

*/

const ExternalLink: React.FC<Param> = ({ href, children, className }) => {
    const classes = useStyle();

    return (
        <Link href={href} target="_blank" rel="noopener noreferrer" className={`${classes.root} ${className}`} color='textSecondary'>
            {children}
        </Link>
    );
}

export default ExternalLink;